import { Component, OnInit } from '@angular/core';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { empModulo } from '../../../diccionarios/empModulo';
import { CrearEmpleadoService } from '../../../services/administrador/crear-empleado.service';

@Component({
  selector: 'app-aprobados-documentacion',
  templateUrl: './aprobados-documentacion.component.html',
  styleUrls: ['./aprobados-documentacion.component.css']
})
export class AprobadosDocumentacionComponent implements OnInit {

  loading: boolean = false;
  listaVacia: boolean = true;
  mostrarCard: boolean = true;
  resposiveFull: string;

  columnDefs: any[];//aggrid
  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;
  textoBuscar: string;
  empModulo: any = {};


  constructor(private _util: UtilsService, private _reporte: CrearEmpleadoService) { }

  ngOnInit() {
    this.empModulo = empModulo;
    this.resposiveFull = this.empModulo.div.resposiveFull;
    this.cargarGrid();
    this.getData();
  }

  cargarGrid() {
    this.columnDefs = [
      {
        headerName: 'Cédula',
        field: 'cedula',
        filter: true,
        width: 180,
        tooltipField: 'cedula',
        tooltipComponentParams: { color: '#ececec' },
      },
      {
        headerName: 'Nombres',
        field: 'nombres',
        sortable: true,
        filter: true,
        width: 280,
      },
      {
        headerName: 'Descripción empresa',
        field: 'empresa.descripcion',
        sortable: true,
        width: 260,
        filter: true,
      },
      {
        headerName: 'Fecha Ingreso',
        field: 'fechaIngreso',
        sortable: true,
        width: 170,
        filter: true,
      },
      {
        headerName: 'Fecha Salida',
        field: 'fechaSalida',
        sortable: true,
        width: 170,
        filter: true,
      },
      {
        headerName: 'Aprueba',
        field: 'userChangeBy',
        sortable: true,
        width: 180,
        filter: true,
      }
    ];

    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.rowSelection = 'multiple';
  }

  getData() {
    this.loading = true;
    this._reporte.getAllAprobados().subscribe((res: any[]) => {
      this.rowData = res;
      this.loading = false;
      this.listaVacia = (res.length === 0) ? true : false;
    }, (err) => {
      this.rowData = [];
      this.loading = false;
      this.listaVacia = true;
      this._util.mensajeErroToast(err.error.message, 2000);
      console.log(err);
    });
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  descargarCsv() {
    //EJEMPLO DE INVOCACION NO DESCOMENTAR
    if (this.rowData.length === 0) {
      this._util.mensajeErroToast('No se encontraron registros para la descarga del archivo.');
      return;
    }
    let cabecera: any[] = [[
      'Cédula',
      'Nombres',
      'Descripción empresa',
      'Fecha Ingreso',
      'Fecha Salida',
      'Aprueba'
    ]];
    const clonLista = this.rowData.map((x) => Object.assign({}, x));
    const data: any[] = [];
    clonLista.forEach((e) => {
      let empresa = '';
      if (e.empresa) {
        empresa = (e.empresa.descripcion === undefined) ? '' : e.empresa.descripcion;
      }
      data.push({
        'Cédula': (e.cedula === undefined) ? '' : e.cedula,
        'Nombres': (e.nombres === undefined) ? '' : e.nombres,
        'Descripción empresa': empresa,
        'Fecha Ingreso': (e.fechaIngreso === undefined) ? '' : e.fechaIngreso,
        'Fecha Salida': (e.fechaSalida === undefined) ? '' : e.fechaSalida,
        'Aprueba': (e.userChangeBy === undefined) ? '' : e.userChangeBy
      });
    });
    let name: string = "data.csv";
    this._util.exportCSV(cabecera, data, name);
  }

  onSelectionChanged(){}
}
